// components/ProtectedUserRoute.js
import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { auth, db } from '../../src/firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';

const ProtectedUserRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isUser, setIsUser] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (currentUser) => {
      if (!currentUser) {
        setIsUser(false);
        setLoading(false);
        return;
      }

      try {
        const userRef = doc(db, 'Usuarios', currentUser.uid);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
          const rol = userSnap.data().rol;
          // Permitir acceso si el rol es 'usuario' o 'vendedor'
          setIsUser(rol === 'usuario' || rol === 'vendedor');
        } else {
          setIsUser(false);
        }
      } catch (error) {
        console.error("Error verificando rol:", error);
        setIsUser(false);
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) return <div>Cargando...</div>;

  if (!isUser) return <Navigate to="/" replace />;

  return children;
};

export default ProtectedUserRoute;
